import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { Spin } from "antd";
import { Toast } from "react-bootstrap";

type User = {
  name?: string | null;
  phone_number?: string | null;
  states?: Array<number>;
  zones?: Array<number>;
  branches?: Array<number>;
  managers?: Array<number>;
  trainers?: Array<number>;
  is_idealtime?: boolean;
};

interface State {
  id: number;
  name: string;
}

interface Zone {
  id: number;
  name: string;
}

interface Branch {
  id: number;
  name: string;
}

interface ServiceDivision {
  id: number;
  name: string;

}

interface Manager {
  id: number;
  name: string;
}

interface Trainer {
  id: number;
  name: string;
}

const AddWizklubTrainerAssignmentToManager = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const jwtToken = Cookies.get("authToken");
  const { webApi, userPermissions } = useUserPermissions();
  const [profileRecord, setProfileRecord] = useState<User | null>(null);
  const [chosenStates, setChosenStates] = useState<number[]>([]);
  const [chosenServiceDivisions, setChosenServiceDivisions] = useState<number[]>([]);
  const [chosenZones, setChosenZones] = useState<number[]>([]);
  const [chosenBranches, setChosenBranches] = useState<number[]>([]);
  const [chosenManagers, setChosenManagers] = useState<number[]>([]);
  const [chosenTrainers, setChosenTrainers] = useState<number[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [zones, setZones] = useState<Zone[]>([]);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [managers, setManagers] = useState<Manager[]>([]);
  const [trainers, setTrainers] = useState<Trainer[]>([]);
  const [serviceDivisions, setServiceDivisions] = useState<ServiceDivision[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [idealTime, setIdealTime] = useState(true);
  const [toastMessage, setToastMessage] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchStateData = async () => {
    const response = await fetch(
      `${webApi}/branches/branches_state_dropdown/`,
      options
    );
    const data =  await response.json();
    const states = data.results.map(
        (state: { state_id: number; name: string; is_active: boolean }) => ({
          id: state.state_id,
          name: state.name,
        })
      );
     setStates(states);
  };

  const fetchManagers = async () => {
    const response = await fetch(
      `${webApi}/employees/user_dropdown_for_team_creation/`,
      options
    );
    const data = await response.json();

    // Transform data from { id, username } to { id, name }
    const transformed = data.map((item: { id: number; username: string }) => ({
      id: item.id,
      name: item.username,
    }));

    setManagers(transformed);
  };


  const fetchTrainers = async () => {
    const response = await fetch(`${webApi}/wizklub/wizklub_trainer_dropdown_based_on_branches/?branches=${chosenBranches}`, options);
    return await response.json();
  }

  const fetchZonesData = async () => {
    const response = await fetch(
      `${webApi}/user/get_zones_dropdown/${chosenStates}/`,
      options
    );
    return await response.json();
  };

  const fetchBranchesData = async () => {
    const response = await fetch(
      `${webApi}/branches/wizklub_branches_dropdown/?zone_id=${chosenZones}`,
      options
    );
    return await response.json();
  };

  const fetchUserProfileData = async () => {
    const response = await fetch(`${webApi}/user/add_update_userprofile/${id}/`, options);
    return await response.json();
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const [stateData, profileData] = await Promise.all([
        fetchStateData(),
        fetchUserProfileData(),
      ]);

      // const states = stateData.results.map(
      //   (state: { state_id: number; name: string; is_active: boolean }) => ({
      //     id: state.state_id,
      //     name: state.name,
      //   })
      // );
      setStates(states);
      setProfileRecord(profileData);
      setChosenStates(profileData.states || []);
      setChosenZones(profileData.zones || []);
      setChosenBranches(profileData.branches || []);
      setChosenServiceDivisions(profileData.service_divisions || [])
      setIdealTime(profileData.is_idealtime);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!checkPermission("add_wizklubtrainerassignment", "wizklubtrainerassignment")) {
      navigate(routes.crmLandingPage);
    } else {
      // fetchData();
      fetchManagers();
      fetchStateData();
    }
  }, [userPermissions]);

  useEffect(() => {
    const fetchZones = async () => {
      if (chosenStates.length > 0) {
        const zonesData1 = await fetchZonesData();
        const zonesData = zonesData1.results;
        const zones = zonesData.map((zone: any) => ({
          id: zone.zone_id,
          name: zone.name,
        }));
        setZones(zones);
      } else {
        // Clear zones and branches if no states are selected
        setZones([]);
        setChosenZones([]);
        setBranches([]);
        setChosenBranches([]);
        setChosenTrainers([]);
      }
    };
    fetchZones();
  }, [chosenStates]);

  useEffect(() => {
    const fetchBranches = async () => {
      if (chosenZones.length > 0) {
        const branchesData1 = await fetchBranchesData();
        const branchesData = branchesData1;
        const branches = branchesData.map((branch: any) => ({
          id: branch.branch_id,
          name: branch.name,
        }));
        setBranches(branches);
      } else {
        // Clear branches if no zones are selected
        setBranches([]);
        setChosenBranches([]);
        setChosenTrainers([]);
      }
    };
    fetchBranches();
  }, [chosenZones]);


  useEffect(() => {
    const fetchTrainers1 = async () => {
      if (chosenBranches.length > 0) {
        const branchesData1 = await fetchTrainers();
        const branchesData = branchesData1;
        const branches = branchesData.map((branch: any) => ({
          id: branch.id,
          name: branch.username,
        }));
        setTrainers(branches);
      } else {
        // Clear branches if no zones are selected
        setTrainers([]);
        setChosenTrainers([]);
      }
    };
    fetchTrainers1();
  }, [chosenBranches]);

  const handleProfileSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsLoading1(true);
    e.preventDefault();

    const updatedProfileRecord = {
      ...profileRecord,
      states: chosenStates,
      zones: chosenZones,
      branches: chosenBranches,
      managers: chosenManagers,
      trainers: chosenTrainers,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(updatedProfileRecord),
    };

    try {
      const url = `${webApi}/wizklub/wizklub_trainer_assignment/`;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        const errorData = await response.json();
        setToastMessage(errorData.phone_number);
        setShowSolidDangerToast(true);
        throw new Error(errorData.detail || "Failed to update profile");
      }

      const data = await response.json();
      console.log("Profile updated successfully:", data);
      navigate(routes.wizklubTrainerAssignmentToManager);
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setIsLoading1(false);
    }
  };

  const availableStates = states.filter(
    (state) => !chosenStates.includes(state.id)
  );
  const availableZones = zones.filter((zone) => !chosenZones.includes(zone.id));
  const availableBranches = branches.filter(
    (branch) => !chosenBranches.includes(branch.id)
  );

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProfileRecord({ ...profileRecord, [name]: value === "true" });
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Wizklb Trainer Assignment</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.wizklubTrainerDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.wizklubTrainerAssignmentToManager}>Wizklb Trainer Assignment</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Wizklb Trainer Assignment</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "15px",
                }}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100vh",
                      paddingTop: "20px",
                    }}
                  >
                    <Spin /> {/* Display loader while loading */}
                  </div>
                ) : (
                  <div className="card-body">
                    <form onSubmit={handleProfileSubmit}>
                      <div className="modal-body light-violet-bg">
                        <div style={{ display: "flex", flexWrap: "nowrap", alignItems: "flex-start" }}>
                          <div
                            className="form-group me-3"
                            style={{
                              flex: 1,
                              marginRight: "45px",
                              marginBottom: "3px",
                            }}
                          >
                            <label className="form-label">Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              placeholder="Enter your name"
                              value={profileRecord ? profileRecord.name || "" : ""}
                              style={{ width: "100%" }}
                              onChange={(e) =>
                                setProfileRecord({
                                  ...profileRecord,
                                  name: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="form-group dual-list-box-container">
                          <label
                            className="form-label"
                            style={{ marginTop: "3px" }}
                          >
                            Manager
                          </label>
                          <DualListBox
                            options={managers}
                            selected={chosenManagers
                              .map((id) =>
                                managers.find((state) => state.id === id)
                              )
                              .filter(
                                (state): state is State => state !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (state) => state.id
                              );
                              setChosenManagers(selectedIds);
                            }}
                          />
                        </div>
                        <div className="form-group dual-list-box-container">
                          <label
                            className="form-label"
                            style={{ marginTop: "3px" }}
                          >
                            States
                          </label>
                          <DualListBox
                            options={availableStates}
                            selected={chosenStates
                              .map((id) =>
                                states.find((state) => state.id === id)
                              )
                              .filter(
                                (state): state is State => state !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (state) => state.id
                              );
                              setChosenStates(selectedIds);
                            }}
                          />
                        </div>
                        <div className="form-group dual-list-box-container">
                          <label className="form-label">Zones</label>
                          <DualListBox
                            options={availableZones}
                            selected={chosenZones
                              .map((id) => zones.find((zone) => zone.id === id))
                              .filter(
                                (zone): zone is Zone => zone !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (zone) => zone.id
                              );
                              setChosenZones(selectedIds);
                            }}
                          />
                        </div>
                        <div className="form-group dual-list-box-container">
                          <label className="form-label">Branches</label>
                          <DualListBox
                            options={availableBranches}
                            selected={chosenBranches
                              .map((id) =>
                                branches.find((branch) => branch.id === id)
                              )
                              .filter(
                                (branch): branch is Branch =>
                                  branch !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (branch) => branch.id
                              );
                              setChosenBranches(selectedIds);
                            }}
                          />
                        </div>
                        <div className="form-group dual-list-box-container">
                          <label className="form-label">Trainers</label>
                          <DualListBox
                            options={trainers}
                            selected={chosenTrainers
                              .map((id) =>
                                trainers.find((trainer) => trainer.id === id)
                              )
                              .filter(
                                (trainer): trainer is Branch =>
                                  trainer !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (trainer) => trainer.id
                              );
                              setChosenTrainers(selectedIds);
                            }}
                          />
                        </div>
                      </div>
                      <div className="modal-footer">
                        <Link
                          className="btn btn-primary"
                          to={routes.wizklubTrainerAssignmentToManager}
                          style={{
                            backgroundColor: "lightcoral",
                            color: "white",
                            marginRight: "5px",
                          }}
                        >
                          Cancel
                        </Link>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isLoading}
                        >
                          {" "}
                          {isLoading1 ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
                <Toast
                  show={showSolidDangerToast}
                  onClose={handleSolidDangerToastClose}
                  id="solidDangerToast"
                  className="colored-toast bg-danger text-fixed-white"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                  style={{
                    position: "fixed",
                    top: "20px",
                    right: "20px",
                    zIndex: 1050,
                  }}
                >
                  <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddWizklubTrainerAssignmentToManager;
